import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b0f3678"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "x-popover" }

import { computed, watchPostEffect, onBeforeUnmount } from 'vue'

interface IProps {
  visible: boolean
  title?: string
  content?: string
  align?: 
  | 'top' 
  | 'top-left'
  | 'top-right' 
  | 'bottom' 
  | 'bottom-left' 
  | 'bottom-right' 
  | 'left' 
  | 'left-top' 
  | 'left-bottom' 
  | 'right' 
  | 'right-top' 
  | 'right-bottom'
  overlayPosition?: 'relative' | 'fixed'
  // 浮层样式
  overlayStyle?: object
  /** 若为true，则不渲染浮层元素到DOM上 */
  disabled?: boolean
  /** 是否在点击其他位置时隐藏气泡弹窗 */
  hideOnBlur?: boolean
}
interface IEmits {
  (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean },
    title: { default: '' },
    content: { default: '' },
    align: { default: 'top-right' },
    overlayPosition: { default: 'relative' },
    overlayStyle: { default: () => ({}) },
    disabled: { type: Boolean, default: false },
    hideOnBlur: { type: Boolean, default: true }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, title: string, content: string, align: 
  | 'top' 
  | 'top-left'
  | 'top-right' 
  | 'bottom' 
  | 'bottom-left' 
  | 'bottom-right' 
  | 'left' 
  | 'left-top' 
  | 'left-bottom' 
  | 'right' 
  | 'right-top' 
  | 'right-bottom', overlayPosition: 'relative' | 'fixed', overlayStyle: object, disabled: boolean, hideOnBlur: boolean }





const isFixedType = computed(() => props.overlayPosition === 'fixed')

function onClickCapture (evt: MouseEvent) {
  if (!props.visible) return
  if (!props.hideOnBlur) return
  let targetEl = evt.target as HTMLElement | null
  let isPopover = false
  while (!isPopover && targetEl) {
    isPopover = targetEl.classList.contains('x-popover__box')
    targetEl = targetEl.parentElement
  }

  if (!isPopover) {
    evt.stopPropagation()
    evt.preventDefault()
    emits('close')
  }
}
const stopEventListen = watchPostEffect((onClean) => {
  onClean(() => {
    document.removeEventListener('click', onClickCapture, true)
  })
  if (props.hideOnBlur && props.visible) {
    document.addEventListener('click', onClickCapture, true)
  }
})

onBeforeUnmount(() => {
  stopEventListen()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "reference"),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body",
          disabled: !_unref(isFixedType)
        }, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["x-popover__box", `x-popover__placement_${__props.align}`]),
                style: _normalizeStyle(__props.overlayStyle)
              }, [
                _renderSlot(_ctx.$slots, "default")
              ], 6), [
                [_vShow, __props.visible]
              ])
            ]),
            _: 3
          })
        ], 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})